<script>
import * as moment from 'moment'

export default {
  filters: {
    commaSeparateArray(value) { return value ? value.join(', ') : '' },

    sumOfMortalities(record) { return record.collection_records ? record.collection_records.reduce((total, colRec) => total + colRec.mortalities, 0) : 0 },
  },

  props: {
    batch: { type: Object, required: true },
    fromDate: { type: String },
    toDate: { type: String },
  },

  computed: {
    recordsInDateRange() {
      return this.batch.records.filter(x =>
        (!this.fromDate || moment(this.fromDate).isSameOrBefore(moment(x.date))) &&
        (!this.toDate || moment(this.toDate).isSameOrAfter(moment(x.date))
        ))
    },

    hasRecordsButNoneInRange() { return this.batch.records && this.batch.records.length > 0 && this.recordsInDateRange.length === 0 },
  },

  methods: {
    isAgeWeeksSameAsPreviousRecord(records, record) {
      let idx = records.indexOf(record);
      if (idx <= 0) return false;
      return records[idx].age_in_weeks === records[idx - 1].age_in_weeks;
    },
  },
}
</script>

<template>
  <div class="table-responsive">
    <table class="table table-bordered table-sm small">
      <thead>
        <tr>
          <th class="text-center">Date</th>
          <th class="text-center">Age <br> (weeks)</th>
          <th class="text-center">Daily Eggs</th>
          <th class="text-center">% Lay</th>
          <!-- <th class="text-center">Weekly % avg</th> -->
          <th class="text-center">Broken</th>
          <th class="text-center">Person(s)</th>
          <th class="text-center">Mortalities</th>
          <th class="text-center">Chicken Balance</th>
          <th class="text-center">Food (kg)</th>
          <th class="text-center">Feed per hen (g/hen)</th>
          <th class="text-center">Cost per egg (R/egg)</th>
          <th class="text-center">Average weight (kg)</th>
        </tr>
      </thead>

      <tbody>
        <tr v-if="hasRecordsButNoneInRange">
          <td colspan="20" class="text-warning text-center h4">
            There are records but none are in the date range you picked above.
          </td>
        </tr>

        <tr v-for="record in recordsInDateRange" :key="record.age_in_days">

          <td class="text-center" style="width:90px">
            <div class="text-muted small" style="">
              {{record.date | formatDate('YYYY-MM-DD')}}
            </div>
          </td>

          <td class="text-center" style="width:110px">
            <span v-if="!isAgeWeeksSameAsPreviousRecord(recordsInDateRange, record)">
              {{record.age_in_weeks}}
            </span>
          </td>

          <td class="text-center">
            {{record.total_eggs}}
          </td>

          <td class="text-center">
            {{record.lay_percentage}}
          </td>

          <!-- <td class="text-center">
            {{record.previous_week_average_lay_percentage}}
          </td> -->

          <td class="text-center">{{record.total_broken}}</td>

          <td class="text-center">{{record.collection_persons | commaSeparateArray}}</td>

          <td class="text-center">{{record | sumOfMortalities}}</td>

          <td class="text-center">{{record.balance}}</td>

          <td class="text-center">{{record.total_food_kg | roundNumber(2)}}</td>

          <td class="text-center">{{record.feed_grams_per_hen | roundNumber(2)}}</td>

          <td class="text-center">{{record.rands_per_egg | roundNumber(2)}}</td>

          <td class="text-center">{{record.average_weight | roundNumber(2)}}</td>

        </tr>
      </tbody>
    </table>
  </div>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/StockBalanceTable.vue